import { Order as OrderComponent } from '../../components/Order';
import { Loading } from '../../../components/Loading';
import { Error } from '../../../components/Error';
import { useActiveOrder } from '../../hooks/useActiveOrder';

export const Active: React.FC = () => {
	const [activeOrderId, { order, error, subscriptionError }] =
		useActiveOrder();

	if (!activeOrderId) {
		return <Error error="No orders in progress." />;
	}

	if (error) {
		return (
			<Error
				error={
					error.message ??
					`Woops! Something went wrong when we tried to find the active order. Active order id: ${activeOrderId}`
				}
			/>
		);
	}

	if (!order) {
		return <Loading />;
	}

	return (
		<div className="active-order mb-3 order-active">
			{subscriptionError && <Error error={subscriptionError.message} />}

			<OrderComponent order={order} />
		</div>
	);
};
